import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { LoginError, LoginStart, SetLoader, LoginSuccess } from '../../store/actions';
import { getLoader } from '../../store/selectors';
import { State } from '../../typings/state';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cmx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  inputForm: UntypedFormGroup;
  redirect: string | null;
  loader: boolean;

  error: string;

  private sub: Subscription;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private store: Store<State>,
  ) {}

  ngOnInit() {
    this.store.dispatch(new SetLoader(false));
    this.inputForm = this.fb.group({
      email: ['', [Validators.required]],
      pass: ['', [Validators.required]],
    });
    this.redirect = this.route.snapshot.queryParams.returnUrl || null;
    this.sub = this.store.pipe(select(getLoader)).subscribe((loader) => (this.loader = loader));
  }

  async onLogin() {
    const user = this.inputForm.controls.email.value;
    const pass = this.inputForm.controls.pass.value;
    let response: any;
    this.store.dispatch(new LoginStart());
    try {
      this.redirect
        ? (response = await this.auth.login(user, pass, this.redirect))
        : (response = await this.auth.login(user, pass));
      this.store.dispatch(new LoginSuccess(response));
    } catch (error) {
      this.store.dispatch(new LoginError());
      if (error.status === 401) {
        this.error = 'form.loginForm.invalidCredentials';
        return;
      }
      this.error = 'views.signin.please_try_again';
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
